<script setup lang="ts">
import NavBar from '@/layouts/nav-bar/NavBar.vue'
import { RouterView } from 'vue-router'
</script>

<template>
  <v-app class="fill-height d-flex">
    <NavBar has-logo />
    <v-main>
      <div
        class="app-content-container boxed-container pa-0 fill-height bg-surface-secondary flex-fill"
      >
        <RouterView />
      </div>
    </v-main>
  </v-app>
</template>
